/* Oblikovanje datumov, imen in števil. Edina odvisnost je jezik vmesnika. */

import { lang } from '../i18n/index.js';

/** Datum iz baze (YYYY-MM-DD) v zapis jezika vmesnika. Prazno vrne prazen niz. */
export function fmtDate(d) {
  if (!d) return '';
  try {
    return new Date(d).toLocaleDateString(lang() === 'en' ? 'en-GB' : 'sl-SI');
  } catch {
    return d;
  }
}

/** Današnji dan kot YYYY-MM-DD po lokalnem času.
 *  Stara verzija je uporabljala toISOString(), ki je v UTC. Slovenija je
 *  poleti UTC+2, zato je med polnočjo in 2:00 vrnil VČERAJŠNJI datum —
 *  tečajnik, ki je po polnoči vpisal let, ga je dobil na napačen dan. */
export function today() {
  const n = new Date();
  const m = String(n.getMonth() + 1).padStart(2, '0');
  const d = String(n.getDate()).padStart(2, '0');
  return `${n.getFullYear()}-${m}-${d}`;
}

/** Starost v letih na današnji dan. */
export function ageOf(dob) {
  if (!dob) return null;
  const d = new Date(dob);
  if (Number.isNaN(d.getTime())) return null;
  const n = new Date();
  let a = n.getFullYear() - d.getFullYear();
  if (n.getMonth() < d.getMonth() || (n.getMonth() === d.getMonth() && n.getDate() < d.getDate())) {
    a--;
  }
  return a;
}

/**
 * Datumu prišteje mesece in vrne YYYY-MM-DD.
 *
 * Konec meseca se prireže: 31. 1. + 1 mesec je 28. (ali 29.) 2., ne 3. 3.
 * Brez tega bi zdravniško z dne 31. 8. veljalo dan dlje, kot bi smelo.
 */
export function addMonths(iso, months) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const day = d.getDate();
  const t = new Date(d.getFullYear(), d.getMonth() + months, 1);
  const lastDay = new Date(t.getFullYear(), t.getMonth() + 1, 0).getDate();
  t.setDate(Math.min(day, lastDay));
  const m = String(t.getMonth() + 1).padStart(2, '0');
  return `${t.getFullYear()}-${m}-${String(t.getDate()).padStart(2, '0')}`;
}

/** Koliko dni je še do danega datuma. Negativno = je že mimo. */
export function daysUntil(iso) {
  if (!iso) return null;
  const a = new Date(`${today()}T00:00:00`);
  const b = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(b.getTime())) return null;
  return Math.round((b - a) / 86400000);
}

export const mesecev = (n) => word(n, ['mesec', 'meseca', 'meseci', 'mesecev'], ['month', 'months']);

/** Začetnici za avatar. */
export function initials(ime, priimek) {
  return `${ime?.[0] ?? '?'}${priimek?.[0] ?? ''}`.toUpperCase();
}

/** Polno ime, ali null če ga tečajnik še ni vpisal. */
export function fullName(u) {
  const s = `${u?.ime ?? ''} ${u?.priimek ?? ''}`.trim();
  return s || null;
}

/** Slovenska sklanjatev ob števcu: 1 dan, 2 dneva, 3 dnevi, 5 dni. */
export function plural(n, one, two, few, many) {
  const mod100 = n % 100;
  if (mod100 === 1) return one;
  if (mod100 === 2) return two;
  if (mod100 === 3 || mod100 === 4) return few;
  return many;
}

/** Angleška množina: 1 day, 2 days. */
export const pluralEn = (n, one, many) => (n === 1 ? one : many);

/** Beseda ob števcu v jeziku vmesnika. */
const word = (n, sl, en) => (lang() === 'en' ? pluralEn(n, ...en) : plural(n, ...sl));

export const dni = (n) => word(n, ['dan', 'dneva', 'dnevi', 'dni'], ['day', 'days']);
export const vaje = (n) => word(n, ['vaja', 'vaji', 'vaje', 'vaj'], ['exercise', 'exercises']);
export const leti = (n) => word(n, ['let', 'leta', 'leti', 'letov'], ['flight', 'flights']);
export const tecajniki = (n) =>
  word(n, ['tečajnik', 'tečajnika', 'tečajniki', 'tečajnikov'], ['student', 'students']);

/** Velikost datoteke za prikaz. */
export function fmtBytes(b) {
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${Math.round(b / 1024)} kB`;
  return `${(b / 1024 / 1024).toFixed(1)} MB`;
}

/** Odstotek, varno tudi pri total = 0. */
export function pct(done, total) {
  if (!total) return 0;
  return Math.round((done / total) * 100);
}
